import { createContext, useContext, useState, FC, ReactNode } from "react";
import CustomToast from "../components/common/CustomToast";
const ToastContext = createContext<ToastContextType | undefined>(undefined);

export const ToastProvider: FC<{ children: ReactNode }> = ({ children }) => {
  const [toastData, setToastData] = useState<ToastParams | null>(null);

  const toast = (params: ToastParams) => {
    setToastData(params);
    setTimeout(() => setToastData(null), params.duration || 4000);
  };

  return (
    <ToastContext.Provider value={{ toast }}>
      {children}
      {toastData && (
        <CustomToast
          open={!!toastData}
          handleClose={() => setToastData(null)}
          title={toastData.title}
          type={toastData.type}
          subtitle={toastData.subtitle}
          duration={toastData.duration}
        />
      )}
    </ToastContext.Provider>
  );
};

export const useToast = (): ToastContextType => {
  const context = useContext(ToastContext);

  if (!context) {
    throw new Error("useToast must be used within a ToastProvider");
  }

  return context;
};

type ToastContextType = {
  toast: (params: ToastParams) => void;
};

type ToastParams = {
  type: "success" | "error";
  title: string;
  subtitle?: string;
  duration?: number;
};
